import { inputNumber } from '../utils/input'
import { Field } from './Field'

interface Props {
  label: string
  min: number
  max: number
  step?: number
  value: number
  display?: string
  onChange: (value: number) => void
}

export function SliderRow({ label, min, max, step, value, display, onChange }: Props) {
  return (
    <Field label={label}>
      <input
        type="range"
        min={min}
        max={max}
        step={step ?? 1}
        value={value}
        onInput={(event) => onChange(inputNumber(event))}
      />
      <span class="value">{display ?? value}</span>
    </Field>
  )
}
